import styled from "styled-components";
const PaymentTypesStyles = styled.div`
    .payment-method-button-40-px,
    .payment-method-button-40-px * {
        box-sizing: border-box;
    }
    .payment-method-button-40-px {
        border-radius: 5px;
        border-style: solid;
        border-color: var(--border-border-primary, rgba(166, 166, 166, 0.2));
        border-width: 1px;
        padding: 12px 10px 12px 10px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: space-between;
        align-self: stretch;
        flex: 1;
        position: relative;
        width: 95px;
    }
    .credit-card-02 {
        flex-shrink: 0;
        height: 17px;
        position: relative;
        overflow: visible;
        margin-bottom: 20px;
    }
    .card {
        color: var(--text-text-primary, #ffffff);
        text-align: left;
        font-family: var(--body-text-font-family, "OpenSans-Regular", sans-serif);
        font-size: var(--body-text-font-size, 14px);
        line-height: var(--body-text-line-height, 24px);
        letter-spacing: var(--body-text-letter-spacing, -0.015em);
        font-weight: var(--body-text-font-weight, 400);
        position: relative;
        align-self: stretch;
        height: 14px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }
    .selected {
        border: 1px solid #7745e0;
    }
    .check {
        position: absolute;
        right: 4px;
    }
`;
const PaymentMethodType = ({ name = "", icon, isSelected, onClick }) => {
    return (
        <PaymentTypesStyles>
            <div className={`payment-method-button-40-px ${isSelected ? "selected" : ""} cursor-pointer`} onClick={onClick}>
                <img className="credit-card-02 cursor-pointer" src={icon} alt={name} />
                {/* {isSelected ? <img src={Check} alt="" height={"18px"} className="check" /> : null} */}

                <div className="card cursor-pointer">{name}</div>
            </div>
        </PaymentTypesStyles>
    );
};

export default PaymentMethodType;
